module.exports = __webpack_public_path__ + "static/media/hot_gs.29bc8ff4.png";